import _ from 'lodash';

function selectLanguage(tag, languages) {
  if (_.isEmpty(tag) || _.isEmpty(languages) || !_.isArray(languages))
    return null;

  let language = languages.find((l) => l.tag === tag);

  if (language == null) {
    const pLanguage = _.head(tag.split('-'));
    // console.log('pLanguage', pLanguage);

    language = languages.find((l) => l.code.language === pLanguage);
    // language = languages.find((l) => _.startsWith(tag, l.code.language));
  }

  if (language == null) {
    language = languages.find((l) => l.tag === 'en');
  }

  return language;
}

export { selectLanguage };
